import { useCallback, memo } from 'react';
import { useIntl } from 'react-intl';
import { ListCell } from '@cbhq/cds-web/cells';
import { VStack } from '@cbhq/cds-web/layout';
import messages from '../messages.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function MainScreen({
  goToCountryScreen,
  goToLanguageScreen,
  languageName,
  countryName,
  countryCode
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const handleOnPress = useCallback(() => goToLanguageScreen(countryCode), [countryCode, goToLanguageScreen]);
  return /*#__PURE__*/jsxs(VStack, {
    width: "100%",
    spacing: 2,
    children: [/*#__PURE__*/jsx(ListCell, {
      outerSpacing: {
        spacing: 0
      },
      title: formatMessage(messages.countryLabel),
      description: countryName,
      accessory: "arrow",
      onPress: goToCountryScreen
    }), /*#__PURE__*/jsx(ListCell, {
      outerSpacing: {
        spacing: 0
      },
      title: formatMessage(messages.languageLabel),
      description: languageName,
      accessory: "arrow",
      onPress: handleOnPress
    })]
  });
}
const MainScreen$1 = /*#__PURE__*/memo(MainScreen);
export { MainScreen$1 as default };
//# sourceMappingURL=MainScreen.js.map
